export default __webpack_public_path__ + "static/media/SpeechLeft.d5fdaaaa.svg";